import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export const PRACTICE_AGENT_SIDEBAR_BUTTON_ID = 'practice-agent-sidebar-button';

@Injectable({ providedIn: 'root' })
export class PracticeAgentWidgetControlService {
  private readonly openRequestSubject = new Subject<void>();
  private readonly visibleSubject = new BehaviorSubject(false);
  private readonly enabledSubject = new BehaviorSubject(false);
  private readonly availableSubject = new BehaviorSubject(false);
  private readonly notificationCountSubject = new BehaviorSubject<number | null>(null);

  readonly openRequested$ = this.openRequestSubject.asObservable();
  readonly visible$ = this.visibleSubject.asObservable();
  readonly enabled$ = this.enabledSubject.asObservable();
  readonly available$ = this.availableSubject.asObservable();
  readonly notificationCount$ = this.notificationCountSubject.asObservable();

  openWidget(): void {
    this.openRequestSubject.next();
  }

  setVisible(visible: boolean): void {
    this.visibleSubject.next(visible);
  }

  setEnabled(enabled: boolean): void {
    this.enabledSubject.next(enabled);
  }

  setAvailable(available: boolean): void {
    this.availableSubject.next(available);
  }

  setNotificationCount(count: number | null): void {
    this.notificationCountSubject.next(count);
  }
}
